module.exports = __webpack_public_path__ + "static/media/arrow-curve-icon.94b19b9e.svg";